import React, { FC } from 'react';
import TeacherFiltersOfType from './TeacherFiltersOfType';
import FilterFeedback from '../FilterFeedback';
import { TeacherFiltersEnum } from '../../constants';
import { useAppSelector } from '../../hooks/useAppDispatch';

type Props = {
  currentBookId?: string;
};

export const TrajectoryTeacherFilters: FC<Props> = ({ currentBookId }) => {
  const book = useAppSelector((state) => state.privatePageSettings.book);
  const activeFilter = useAppSelector((state) => state.filters.activeFilter);
  const isOutdated = useAppSelector((state) => state.filters.isOutdated);
  const noResultsFound = useAppSelector((state) => state.filters.noResultsFound);
  const newResults = useAppSelector((state) => state.filters.newResults);
  const bookId: string | undefined = currentBookId ? currentBookId : !!book ? book.id : undefined;

  return bookId ? (
    <>
      <TeacherFiltersOfType type={activeFilter as TeacherFiltersEnum | undefined} bookId={bookId} />
      {!!activeFilter && (
        <FilterFeedback
          isOutdated={isOutdated}
          noResultsFound={noResultsFound}
          newResults={newResults}
        />
      )}
    </>
  ) : null;
};
